module.exports = __webpack_public_path__ + "static/media/drink.140a3795.png";